import Vue from "vue";
import Vuex from "vuex";
import Server from "src/server";

// modules
import User from "./user";
import Connection from "./connection";
import Workflow from "./workflow";
import Node from "./node";
import Log from "./log";
import Workspace from "./workspace";

Vue.use(Vuex);

export default new Vuex.Store(
  {
    modules:
    {
      userStore: User,
      connStore: Connection,
      wfStore: Workflow,
      nodeStore: Node,
      logStore: Log,
      wsStore: Workspace,
    },

    state:
    {
      init: false,
      version: "",
      customerNum: "",
      license: "",
      expiration: null,
      modules: null,
      engineUrl: ""
    },

    mutations:
    {

    },

    actions:
    {
      async init(context) {
        // get app information
        var info = await Server.get("getAppInfo").promise;
        if (info.data.success) {
          context.state.version = info.data.version;
          context.state.customerNum = info.data.customerNum;
          context.state.license = info.data.license;
          context.state.expiration = info.data.expiration;
          context.state.modules = info.data.modules;
          context.state.engineUrl = info.data.engineUrl;
        }

        var token = localStorage.getItem("token");
        if (token) {
          // wait for user to finish setting before other calls
          await context.dispatch("userStore/setUser", { token: token });
          context.dispatch("wsStore/setWorkspaces");
          context.dispatch("wfStore/setWorkflows");
          context.dispatch("connStore/setConnections");
          context.dispatch("logStore/setLogs");
          context.dispatch("userStore/setUsers");
          context.dispatch("userStore/setGroups");
          context.dispatch("nodeStore/setNodeTypes");
        }
        else {
          context.state.userStore.isLoading = false;
        }
        context.state.init = true;
      },

      reset(context) {
        context.dispatch("userStore/reset");
        context.dispatch("wsStore/reset");
        context.dispatch("wfStore/reset");
        context.dispatch("connStore/reset");
        context.dispatch("logStore/reset");
        context.dispatch("nodeStore/reset");
      },

      setModules(context) {

      }



    },

    getters:
    {

    }
  });



// WEBPACK FOOTER //
// ./src/store/store.js